import Vue from 'vue'
import store from '@/store'
import {validForm} from '@/utils/index.js'
import config from '@/utils/config'
import Cookie from 'js-cookie'
import md5 from 'js-md5'
import local from './storage/local.js';
const MobileDetect = require('mobile-detect')  // 获取设备参数
const md = new MobileDetect(window.navigator.userAgent)
const Fly=require("flyio/dist/npm/fly");
import layer from 'sky-layer'
import path from '../../config/index'
// import "babel-polyfill"    //ie，低版本浏览器兼容 暂时注释掉：是否真的有这个必要兼容低版本浏览器
Vue.prototype.$layer = layer(Vue);
// 全局变量设置
window.Cookie = Cookie;
//清除cookie
window.clearCookie = function () {
  console.log("====== 清除登录信息 =======");
  Cookie.remove('userSeq');
  Cookie.remove('keyCode');
  Cookie.remove('openid');
  Cookie.remove('customerCode');
  Cookie.remove('UA');
  store.commit('setIsLogin', false);
};
window.$clone = function cloneObjectFn (obj){ // 对象复制
  return JSON.parse(JSON.stringify(obj))
};
//判断是否mac ios设备
window.$isMac =  function() {
  return /macintosh|mac os x/i.test(navigator.userAgent);
};
//处理分享url
window.$shareUrl = function(url) {
  let surl =url.split('?');
  if(surl.length > 1){
    if(surl[1].indexOf("platform") != -1){
      surl[1] = surl[1].replace('platform=app', "share=msg");
    }else {
      surl[1] =  surl[1] + "&share=msg"
    }
  }else {
    surl[1] = "share=msg"
  };
  return surl[0] + '?' + surl[1]
}
Vue.prototype.$isMac = $isMac();
window.os = md.os();
Vue.prototype.$os = md.os();
window.md5 = md5;
window.fly = new Fly;
window.validForm = validForm   //全局验证方法
//全局变量--------------------------------------------------------------------------------------strat
let protocol = 'ws://'
if(window.location.protocol === 'https:'){
  protocol = 'wss://'
}

let urlHeader = "", hostUrl = window.location.host;
// console.log(hostUrl);
if (hostUrl == 'wap.cwhisky.com') { // 正式环境
  urlHeader = "";
} else if (hostUrl == 'wap-pre.cwhisky.com') { // 准生产环境
  urlHeader = "-pre";
} else if (hostUrl == 'test.wap.cwhisky.com') { //测试环境
  urlHeader = "-test";
} else {
  urlHeader = path.dev.LocalService
}
// console.log(urlHeader)
path.dev.proxyTable["/api/"].target = window.location.protocol + '//'+ urlHeader +'wap.cwhisky.com/'+ path.dev.version +'/api/';
path.dev.proxyTable["/core/"].target = window.location.protocol + '//' + urlHeader + 'wap.cwhisky.com/'+ path.dev.version +'/core/';
path.dev.proxyTable["/dbcenter/"].target = window.location.protocol + '//' + urlHeader + 'dbcenter.cwhisky.com/dbcenter/';
path.dev.proxyTable["/cwhisky-jp-app-api/"].target = window.location.protocol + '//' + urlHeader + '.cwhisky.com/'+ path.dev.version +'/cwhisky-jp-app-api/';
path.dev.proxyTable["/cwhisky-jp-opr-api/"].target = window.location.protocol + '//' + urlHeader + 'opr.cwhisky.com/cwhisky-jp-opr-api/';

let webSocketUrl = protocol +  "websocket"+ urlHeader +".cwhisky.com/websocket/";
Vue.prototype.$weosocket = webSocketUrl;   //正式webscoket地址
// console.log(webSocketUrl)
Vue.prototype.$live = window.location.protocol  + '//waptv.cwhisky.com/' +  '?c=activity&a=live&id=';   //目睹解析地址地址

//todo:目睹的解析地址是在目睹的深度配置里面填写的地址
Vue.prototype.bootRatio = 0.05;   //佣金比例
Vue.prototype.servicePhone = '4008305299';   //客服电话号码  //使用方法   :href="`tel:${servicePhone}`"
Vue.prototype.uploadCommon = config.commonApi + "common/core/uploadObject2OSS" //上传地址;
Vue.prototype.v_config = config;
//全局变量--------------------------------------------------------------------------------------end
let ua = window.navigator.userAgent.toLowerCase();
//微信浏览器下，禁止支付宝支付 反之禁止微信支付
Vue.prototype.$UA = "browser";
//网页授权
if(ua.match(/MicroMessenger/i) == 'micromessenger'){
  local.set('client', 1);
  local.set('appOs', 0);
  Cookie.set("UA", "wechat");
  Vue.prototype.$UA = "wechat"
  let href = window.location.href;
  let openid = Cookie.get("openid");
  if (href.match(/code/i) != 'code' && !openid) { //表示没授权过
    window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + config.appId + "&redirect_uri=" +  escape(href) + "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
  }
  //授权了但是Cookie里没有openid
  if (href.match(/code/i) == 'code' && !openid){
    let strs = href.split("?code=");
    let WXcode = strs[1].split("&state")[0];
    //用code去请求，获得openid
    fly.get(config.wapApi + 'weixin/getOpenId/' + WXcode)
      .then((res) => {
        //todo:坑点，后台返回来的接口数据，有时候是json有时候是字符串
        if(res.data.openid) {
          Cookie.set('openid',res.data.openid);
          window.location.href = href.replace(window.location.search,"");
        }else {
          Cookie.set('openid',JSON.parse(res.data).openid);
          window.location.href = href.replace(window.location.search,"");
        }
      });
  }
  if (href.match(/code/i) == 'code' && openid && openid != 'undefined'){
    window.location.href = href.replace(window.location.search,"");
  }
}
fly.config.timeout=10000;
// 请求拦截器-----------------------------------------------------------start
let urlFly = window.location.host;
// console.log(urlFly)
if (urlFly.indexOf('dev.wap') >= 0) {
  urlFly = 'http://dev.app.cwhisky.com';
} else if (urlFly.indexOf('cgf.cwhisky.com')>=0 || urlFly.indexOf('test.wap') >=0 ) {
  urlFly = 'http://test.app.cwhisky.com';
} else if (urlFly.indexOf('wap-pre.') >= 0) {
  urlFly = 'http://pre.app.cwhisky.com';
}else {
  urlFly = 'https://app.cwhisky.com';
}
// console.log(urlFly)
fly.interceptors.request.use((request) => {
  let num = request.url.indexOf('{{app}}');
  request.headers["Authentication"]=Cookie.get('keyCode')||'';
  if(num!=-1){
    request.url = urlFly+(request.url.slice(num+7));
  }
  request.headers["Accept"]="application/json";
  request.headers["platform"]="wap";
  request.headers["mode"]=md.mobile();
  request.headers["system"]=md.os();
  request.headers["apiversion"]="v3.9.3";
  if (request.url == "/core/common/core/uploadObject2OSS") {
    request.headers["Content-type"]='multipart/form-data';
  } else {
    request.headers["Content-type"]='application/json;charset=UTF-8';
  }
  request.headers["X-Requested-With"]='XMLHttpRequest';
  // request.headers["X-Tag"]="flyio";
  return request
})
// 请求拦截器-----------------------------------------------------------end

//接口异常，或者报错的时候的处理
function errorcb(){
  Vue.prototype.$layer.closeAll();
  if(Vue.prototype.$dialog.loading) Vue.prototype.$dialog.loading.close();
}
window.$clearObj =  function clearObj(obj) {
  let target = obj;
  for(let key in target){
    if (target[key] instanceof Array) {
      target[key] = []
    } else {
      target[key] = null;
    }
  }
  return target;
}
// 返回拦截器-----------------------------------------------------------start
//todo:神经病的接口，判断接口是否超时的判断，拍卖一套，商城一套，而且判断的字段不一样，拍卖的要通过code和state来判断，商城通过code来判断，拍卖state===1是正常。商城要code==="0000"才正常
fly.interceptors.response.use(
  (response, promise) => {
    //response.data.state存在说明是拍卖的接口
    if(response.data.state != null) {
      //state === 0 ,接口报错，要弹出报错信息，并且关闭一切loading动画
      //todo:  当前是出价者最高出价的时候的地方,因为后台说没办法把data改成0 ，state改成1，所以只能在这里增加一个文字判断
      if((response.data.state === 0 || response.data.state === -1 || response.data.state === -2) && response.data.message != '您目前是最高出价'){
        //其他类型的报错，直接弹出报错信息
        // Vue.prototype.$dialog.toast({
        //   mes: response.data.message,
        // });
        Vue.prototype.$toast({
          duration: 1500,
          position: 'bottom',
          message: response.data.message,
        });
        errorcb();
      }else if(response.data.state === 20001 || response.data.state === 20002){
      //  state === 20001 或 state === 20002   表示拍卖接口返回token过期，需要重新登录
        // Vue.prototype.$dialog.toast({
        //   mes: '登录超时，请重新登录',
        // });
        Vue.prototype.$toast({
          duration: 1500,
          position: 'bottom',
          message: '登录超时，请重新登录'
        });
        clearCookie();
        if(local.get('appOs') !== '1'){     //local.get('appOs') !== '1' 代表是h5页面     === 1代表是在app中的页面
          window.location.reload();
        }else if(os === 'iOS'){
          window.webkit.messageHandlers.goLogin.postMessage('0');
        }else if(os === 'AndroidOS'){
          window.webkit.goLogin();
        }
      }
    }else {
    //  商城的接口
      if(response.data.code && response.data.code !== '0000'){
        //code === '0001'  或者  code === '0002'   表示商城接口返回token过期，需要重新登录
        if(response.data.code === '0001' || response.data.code === '0002'){
          // Vue.prototype.$dialog.toast({
          //   mes: '登录超时，请重新登录',
          // });
          Vue.prototype.$toast({
            duration: 1500,
            position: 'bottom',
            message: '登录超时，请重新登录'
          });
          clearCookie();
          if(local.get('appOs') !== '1'){     //local.get('appOs') !== '1' 代表是h5页面     === 1代表是在app中的页面
            window.location.reload();
          }else if(os === 'iOS'){
            window.webkit.messageHandlers.goLogin.postMessage('0');
          }else if(os === 'AndroidOS'){
            window.webkit.goLogin();
          }
        }else if(response.data.code == "您的访问太快了，请休息一会儿吧！"){     //todo:又是一个好玩的，后台接口访问频率太快的时候，后台要求要用code返回文字给前端判断
          // Vue.prototype.$dialog.toast({
          //   mes: "您的操作太频繁了，请稍后再试",
          // });
          Vue.prototype.$toast({
            duration: 1500,
            position: 'bottom',
            message: "您的操作太频繁了，请稍后再试"
          });
        }else if(response.data.code !== '1000' && response.data.code !== '1905' && response.data.code !== '000000') {
          //其他类型的报错，直接弹出报错信息
          errorcb();
          // Vue.prototype.$dialog.toast({
          //   mes: response.data.message,
          // });
          Vue.prototype.$toast({
            duration: 1500,
            position: 'bottom',
            message: response.data.message
          });
        }
      }
    }

    return promise.resolve(response.data);
  },
  (err, promise) => {
  	switch(err.status) {
		case 403:
		Vue.prototype.$dialog.toast({mes:'403'});
		break;
	  case 404:
		Vue.prototype.$dialog.toast({mes:'404'});
      break;
    case 405:
    Vue.prototype.$dialog.toast({mes:'405'});
      break;
    case 0:
    default:
	}
    errorcb();
    return promise.resolve()
  }
)
// 返回拦截器-----------------------------------------------------------end
Date.prototype.Format = function(fmt) { //author: meizz
  var o = {
      "M+": this.getMonth() + 1, //月份
      "d+": this.getDate(), //日
      "h+": this.getHours(), //小时
      "m+": this.getMinutes(), //分
      "s+": this.getSeconds(), //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
};


// 调用方法  时间格式化
window.formtDate = function(date,type){
    if(!date) return;
    switch(type){
        case 1:
            return new Date(date).Format("yyyy.MM.dd");
            break;
        case 2:
            return new Date(date).Format("yyyy.MM.dd hh:mm:ss");
            break;
        case 3:
            return new Date(date).Format("yyyy-MM-dd hh:mm:ss");
            break;
        case 4:
            return new Date(date).Format("yyyy.MM.dd hh:mm");
            break;
        case 5:
            return new Date(date).Format("MM.dd hh:mm");
            break;
        case 6:
            return new Date(date).Format("MM/dd/yyyy hh:mm:ss");
            break;
        case 7:
            return new Date(date).Format("MM/dd");
            break;
        case 8:
            return new Date(date).Format("hh:mm");
            break;
        case 9:
            return new Date(date).Format("yyyy/MM/dd hh:mm:ss");
            break;
        case 10:
            return new Date(date).Format("yyyy-MM-dd hh:mm");
            break;
        case 11:
        return new Date(date).Format("yyyy-MM-dd");
            break;
        case 12:
            return new Date(date).Format("MM月dd日 hh:mm");
            break;
      case 13:
          return new Date(date).Format("MM-dd hh:mm:ss");
          break;
      case 14:
          return new Date(date).Format("M月d日 hh:mm");
          break;
      case 15:
          // 商品详情 用于摇号参与成功后 提示框告知用户开奖时间
          return new Date(date).Format("yyyy年MM月dd日 hh:mm");
          break;
    }
};
/**
 * 时间样式转变
 * timeStr yyyy-MM-dd hh:mm:ss
 *
 **/
window.getTimeCprNowadays = function(timeData) {
    var timeStr = new Date(timeData).Format("yyyy-MM-dd hh:mm:ss");    //先写死输入格式，后续有需要再用变量增加
    var myDate = new Date();
    var timeShow = "";
    var time = "";
    var tmp = 0;
    if (timeStr && timeStr.indexOf(" ")) {
        time = timeStr.split(" ");
    } else {
        return timeStr;
    }
    var time_fullyear = time[0];
    var time_hour = time[1];
    var fullyearArray = time_fullyear.split("-");
    var hourArray = time_hour.split(":");
    if ((myDate.getMonth()+1) == fullyearArray[1] && myDate.getFullYear() == fullyearArray[0]){
        if (myDate.getDate() - fullyearArray[2] == 1) {
            timeShow = "昨天";
        } else if (myDate.getDate() - fullyearArray[2] > 1) {
            timeShow = timeStr;
        } else {
           let sec = (myDate - timeData)/1000;
           if(sec/60 < 1){
             timeShow = "刚刚";
           } else if((tmp = parseInt(sec/60 + 0.5)) < 60){
             timeShow = `${tmp}分钟前`;
           }else if((tmp = parseInt(tmp/60 + 0.5)) < 24){
             timeShow = `${tmp}小时前`;
           }
        }
    }else {
        timeShow = timeStr;
    }
    return timeShow
};


Vue.prototype.formtDate = window.formtDate;
Vue.prototype.getTimeCprNowadays = window.getTimeCprNowadays;
// 全局过滤器
// replaceSG---去掉空格
Vue.filter('replaceSG', function (value) {
  if (!value) return ''
  value = value.replace(/\s/g,"")
  return value
})
//电话号码带****
Vue.filter('phoneText', function (value) {
  if (!value) return ''
  value = value.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
  return value
})
//时间只取月份
Vue.filter('replaceTime', function (value) {
  if (!value) return ''
  value = value.substring(5,16);
  return value
})
//返回的价格大于万就转成简写，并且去掉小数点后面的
Vue.filter('Bigprice', function (value) {
	if (!value && value!=0) return ''
  if(parseInt(value)>=100000){
  	value = value/10000 + '万';
  }else {
   	// if(value.split('.')[0]) {
   	// 	value = value.split('.')[0]
   	// }
  }
  return value
});
//格式化价格，带逗号
Vue.filter('fmoney', function (s) {
  let n = 1,d;
  s = parseFloat((s + "").replace(/[^\d\.-]/g, "")) + "";
  //  + ""  是为了把数字转换成字符串
  var l = s.split(".")[0].split("").reverse();    //不保留小数点后面
  if(s.split(".")[1]){
    d  = '.' + s.split(".")[1];  //小数点后
  }else {
    d  = ''
  }
  let t = "";
  //根据长度切割
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");
  }
  return t.split("").reverse().join("") + d;
});
//返回字符串的第一位和最后一位，中间都是****
Vue.filter('stringX', function (value) {
	if (!value) return ''
	if(value.length > 2){
		var num = value.length - 2;
		var s = ''
		for(var i = 0; i < num; i++){
			s += '*'
		}
		value = value.substr(0,1)+ s + value.substr(value.length-1,1)
	}else {
		value = value.substr(0,1) + '*'
	}
  return value
});
//序号格式化   比如传1   就格式化001
Vue.filter('fnumber', function (value) {
  if (!value && value!=0) return ''
  if(parseInt(value) < 10){
    value = '00' + value;
  }else if(parseInt(value) >= 10 && parseInt(value) < 100){
    value = '0' + value;
  }else if(parseInt(value) >= 100){
    value = value;
  }
  return value
});

//转成百分比
Vue.filter('toPercent', function (value) {
  return (Math.round(value * 10000)/100) + '%';
});



// WEBPACK FOOTER //
// ./src/utils/bootstrap.js